import { Chip } from '@/components/ui/chip';
import { FlexRow } from '@/components/ui/flex';
import { Multiselect } from '@/components/ui/multiselect';
import { Text } from '@/components/ui/text';
import { useSharedKnowledgeGroupsService } from '@/services/sharedFiles';
import { SearchBar } from '@/shared/SearchBar';
import { NO_GROUP_TOKEN } from '@ditto/shared';
import { ChevronDown } from 'lucide-react';
import { useMemo, type FC } from 'react';

export const Filters: FC<{
  selectedGroups: string[];
  setSelectedGroups: (groups: string[]) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
}> = ({ selectedGroups, setSelectedGroups, searchString, setSearchString }) => {
  const { groups, isLoading: groupsLoading } =
    useSharedKnowledgeGroupsService();

  const groupOptions = useMemo(() => {
    const options =
      groups?.map(group => ({
        label: group.name,
        value: group.id,
      })) || [];
    return [{ label: 'No Group', value: NO_GROUP_TOKEN }, ...options];
  }, [groups]);

  const handleGroupChange = (groups: string[]) => {
    setSelectedGroups(groups);
  };

  return (
    <FlexRow gap="2">
      <SearchBar
        searchString={searchString}
        setSearchString={setSearchString}
        placeholder="Search files..."
      />
      <Multiselect
        options={groupOptions}
        selected={selectedGroups}
        onChange={handleGroupChange}
        placeholder="Filter by knowledge group..."
        disabled={groupsLoading}
        trigger={
          <Chip>
            <Chip.Label>
              <FlexRow gap="1">
                <Text variant="body-sm">Group</Text>
                <Text variant="body-sm">
                  {selectedGroups.length > 0 && `(${selectedGroups.length})`}
                </Text>
              </FlexRow>
            </Chip.Label>
            <ChevronDown size={16} />
          </Chip>
        }
      />
    </FlexRow>
  );
};
